import Box from 'components/shared/Box'
import { RadioTileGroupWrapper } from 'components/shared/RadioTileGroup/RadioTileGroup.styles'
import styled from 'styled-components/macro'
import { respondAbove } from 'styles/mediaQueries'

export const VoucherFormContainer = styled(Box)`
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 10px 24px 24px;

    @media ${respondAbove.xl} {
        padding: 20px 80px 40px;
    }

    ${RadioTileGroupWrapper} {
        > ${Box} {
            width: 100%;
        }
    }

    .divider {
        width: 100%;
        border-radius: 4px;
        border-top: 2px solid ${({ theme }) => theme.colors.grayscale_300};
    }
`

export const CancelButton = styled.button`
    background: none;
    border: 0;
    cursor: pointer;
    padding: 0;
    color: ${({ theme }) => theme.colors.grayscale_800};
    font-size: 16px;
    font-weight: ${({ theme }) => theme.textVariants.body16Strong.fontWeight};
    font-family: ${({ theme }) => theme.textVariants.body16Strong.fontFamily};
`
